import React from "react";
import attachment_pin_02 from "../../assets/icons/attachment_pin_02.png";
import cross_icon from "../../assets/icons/cross_icon.png";

const CreateSupportTicket = ({ setCreateSupportModal }) => {
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex flex-col ">
          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Create support ticket</div>
          </div>
          <div
            className="absolute top-5 right-4 cursor-pointer"
            onClick={() => setCreateSupportModal(false)}
          >
            <img src={cross_icon} alt="cross icon" />
          </div>
          <div>
            <p className="text-[14px] text-[#828282] mt-4">Ticket Title</p>
            <input
              type="text"
              placeholder="Enter the title here"
              className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
            />

            <p className="text-[14px] text-[#828282] mt-4">Description</p>
            <textarea
              type="text"
              placeholder="Enter the ticket description here"
              className="text-[16px] border w-full h-32 border-[#95C2FF] p-2 rounded-lg"
            />
          </div>
          <div className="flex mt-2">
            <img
              src={attachment_pin_02}
              alt="attachment"
              className="object-contain w-6"
            />
          </div>
          <div className="flex justify-between my-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={() => setCreateSupportModal(false)}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={() => setCreateSupportModal(false)}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateSupportTicket;
